// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3_BuX","productName":"Table_productName__pL_FY"};